// extracted by mini-css-extract-plugin
export default {"category_wrapper":"home_category_wrapper__+1hrM","wrapper":"home_wrapper__bSAxK","categories__loader":"home_categories__loader__wfco+"};